<template>
  <v-dialog
    v-model="dialog"
    width="70%"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="teal lighten-2"
        icon
        dark
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>monetization_on</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Account Search
      </v-card-title>

      <v-card-text>

        <v-text-field
          class="pt-0 pb-0 mt-8 mb-0 mr-2 ml-4 search-input purple-input"
          :loading="searching"
          color="teal"
          label="Search..."
          md-layout="box"
          autocomplete="off"
          v-model="search"
          append-outer-icon="search"
          @click:append-outer="searchAccount"
          v-on:keyup.enter="searchAccount"
          search-input=""
          @input="setSearch"
          @input.native="setSearch"
        ></v-text-field>

        <v-data-table
          :headers="searchResultHeaders"
          :items="searchResultAccounts"
          :loading="searching"
          :items-per-page="-1"
          hide-default-footer
          fixed-header
          :height="searchResultAccounts.length > 7 ? 400 : 'auto'"
        >

          <template v-slot:item.login="{ item }">
            <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              dark
              icon
              color="teal"
              @click="$store.dispatch('manual_transaction/open', item)"
              v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: ['balance', 'refund', 'bonus', 'freespins']})">
              <v-icon>monetization_on</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="warning"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
    <manual-transaction text="" size="icon" />
  </v-dialog>


</template>

<script>
  import { API } from '@/utils/api'
  import { get } from 'lodash'

  export default {

    props: [ 'entity_id' ],
    components: {
      ManualTransaction: () => import('@/components/helper/ManualTransaction'),
    },

    data: () => ({
      dialog: false,
      search: '',
      searching: false,
      searchResultAccounts: [],
      searchResultHeaders: [
        { text: 'Account ID', value: 'account_id', sortable: false },
        { text: 'Login', value: 'login', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Created', value: 'created', sortable: false },
        { text: 'Balance', value: 'balance', sortable: false },
        { text: 'Bonus', value: 'bonus', sortable: false },
        { text: '#', value: 'action', sortable: false },
      ]
    }),

    methods: {

      setSearch (e) {
        if (!e) {
          this.search = ''
        } else if (typeof e === 'string') {
          this.search = e
        } else if (typeof e === 'object') {
          this.search = e.srcElement.value
        }
      },

      searchAccount () {
        this.searching = true
        return API.call('/$v/account/search.json', { value: this.search }, null, this.entity_id).then(resp => {
          this.searchResultAccounts = resp.data
          this.search = ''
        }).catch(e => {
        }).finally((r) => {
          this.searching = false
        })
      },

    }
  }
</script>

<style>
</style>
